import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { ButtonPrimary } from 'ui';
import { SpinLoader } from 'app/components';
import { routeConstants } from 'app/routes/route-constants';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { CodetableListComponentProps } from 'app/area/codetable/list/list-items/types';
import { NumberOfResults } from 'app/area/codetable/list/search';
import { CodetableListItems } from 'app/area/codetable/list/list-items';
import { SearchFilters } from 'app/area/search-filters/search-filters';

import { UserGroupCodeModal } from './user-group-code-modal';

import styles from './user-group-list-component.scss';

const buttonComponent = ({ onClick, children }) => {
  return <div className="dropdown-item" onClick={onClick}>
    {children}
  </div>;
};

export class UserGroupListComponent extends Component<CodetableListComponentProps> {
  private addLinkFactory = (label: string, breadcrumbs: number[], parentId: number, duplicateId?: number) => {
    if (isDefinedIncludingZero(duplicateId)) {
      return <Link to={routeConstants.codetableAdministrationDuplicateCodeFor(breadcrumbs, duplicateId)}
        className="dropdown-item">
        {label}
      </Link>;
    }

    const { codetableId, codetableOptions, loadCodetableOptions, translation } = this.props;

    return <UserGroupCodeModal
      label={label}
      codetableId={codetableId}
      breadcrumbs={breadcrumbs}
      parentId={parentId}
      codetableOptions={codetableOptions}
      loadCodetableOptions={loadCodetableOptions}
      ButtonComponent={buttonComponent}
      translation={translation}
    />;
  };

  public render() {
    const { isHierarchy, isHierarchyMode, shouldRenderList,
      shouldRenderSpinLoader, hasCategoryMetadata, hasSelectedCategory,
      breadcrumbs, codetableId, codeId, codeListBranch, rootBranch, codeAccessConfiguration,
      codeListBranchState, loadFromParent, expandCodeItem, deleteCodeItem,
      codeAccessConfiguration: { canCreate } = {}, loadCodesAccess, clearCodesAccess,
      itemAccess, fetchingItemAccess, codetableOptions, loadCodetableOptions,
      translation } = this.props;

    const rightToolbar = canCreate && <UserGroupCodeModal
      label={translation.add_new}
      codetableId={codetableId}
      breadcrumbs={breadcrumbs}
      parentId={undefined}
      codetableOptions={codetableOptions}
      loadCodetableOptions={loadCodetableOptions}
      ButtonComponent={ButtonPrimary}
      translation={translation}
    />;

    return <SearchFilters {...this.props}
      rightToolbar={rightToolbar}>
      <div className={`${styles.codetableListContainer} ${styles.codetableListCenter}`}>
        <div className={styles.codetableListHolder}>
          <div className={styles.numberOfResults}>
            {(!hasCategoryMetadata || (hasCategoryMetadata && hasSelectedCategory))
              && <NumberOfResults
                rootBranch={rootBranch}
                translation={this.props.translation} />}
          </div>

          {shouldRenderSpinLoader ? <SpinLoader /> : undefined}
          {
            shouldRenderList && <div className={`${styles.listItemsContainer} ${isHierarchyMode ? styles.hierarchyResults : ''}`}>

              <div className={styles.listItems}>
                <CodetableListItems
                  itemAccess={itemAccess}
                  fetchingItemAccess={fetchingItemAccess}
                  breadcrumbs={breadcrumbs}
                  treeDepthLevel={0}
                  hierarchyMetadata={[]}
                  isZebra={undefined}
                  codetableId={codetableId}
                  codeId={codeId}
                  isHierarchyMode={isHierarchyMode}
                  isHierarchy={isHierarchy}
                  codeAccessConfiguration={codeAccessConfiguration}
                  codeListBranchState={codeListBranchState}
                  codeListBranch={codeListBranch}
                  loadFromParent={loadFromParent}
                  expandCodeItem={expandCodeItem}
                  deleteCodeItem={deleteCodeItem}
                  loadCodesAccess={loadCodesAccess}
                  clearCodesAccess={clearCodesAccess}
                  parentId={undefined}
                  translation={translation}
                  addLinkFactory={this.addLinkFactory} />
              </div>
            </div>
          }
        </div>
      </div>
    </SearchFilters>;
  }
}
